import React, { FC } from 'react';
import { IconCheck } from '../../utils/icons';
import { Step } from './types';

const DOT_BASE =
    'w-[30px] h-[30px] rounded-full border-[1.5px] flex items-center justify-center text-[12px] font-bold transition-all';

const dotClass = (active: boolean, done: boolean): string => {
    if (active) {
        // Gold glow keeps its literal rgba: no shadow token carries a hue.
        return `${DOT_BASE} border-accent bg-accent text-white shadow-[0_2px_8px_rgba(200,169,126,0.4)]`;
    }
    // Completed dots keep the literal status green: --up (#085041) is the
    // success TEXT value and would visibly darken the filled dot.
    if (done) return `${DOT_BASE} border-[#1C7A5A] bg-[#1C7A5A] text-white`;
    return `${DOT_BASE} border-border-token bg-surface text-muted`;
};

interface Props {
    steps: Step[];
    current: number;
    done: boolean[];
    onSelect: (index: number) => void;
}

export const Stepper: FC<Props> = ({ steps, current, done, onSelect }) => (
    <div className="flex items-start mb-[22px] px-1.5">
        {steps.map((entry, index) => (
            <div key={entry.label} className="flex items-start flex-1 last:flex-none">
                <button
                    type="button"
                    className="flex flex-col items-center gap-[7px] border-0 bg-transparent cursor-pointer p-0"
                    onClick={() => onSelect(index)}
                >
                    <span className={dotClass(index === current, done[index])}>
                        {done[index] && index !== current ? (
                            <IconCheck width={16} height={16} stroke="#FFF" />
                        ) : (
                            index + 1
                        )}
                    </span>
                    <span
                        className={`text-[11.5px] font-semibold whitespace-nowrap max-[560px]:hidden ${
                            index === current ? 'text-text-1' : 'text-muted'
                        }`}
                    >
                        {entry.label}
                    </span>
                </button>
                {index < steps.length - 1 && (
                    <div
                        className={`flex-1 h-0.5 mt-[15px] mx-1.5 rounded-[1px] ${
                            done[index] ? 'bg-[#1C7A5A]' : 'bg-track'
                        }`}
                    />
                )}
            </div>
        ))}
    </div>
);
